<div class="matCardComponent" *ngIf="!isLoadingCard">
    <ng-container *transloco="let translate">
        <mat-card class="appMatcard">
            <mat-card-content class="cardContent">
                <div class="leftActionsContainer">
                    <div [hidden]="!showAppCheckBox || (isPackagePage && asset.assetType === 'PACKAGE')">
                        <material-checkbox
                            [disabled]="disableSelection"
                            (click)="$event.stopPropagation()"
                            [name]="translate('Select App')"
                            [model]="asset.selected"
                            (modelChange)="asset.selected = $event; logChange.emit(asset)"></material-checkbox>
                    </div>
                    <div
                        class="keyIconContainer"
                        *ngIf="
                            (asset?.serviceOrganizationId || asset?.organizationId) === currentOrgDetails?.id &&
                            (asset?.serviceOrganizationId || asset?.organizationId) !== currentOrgDetails?.providerOrganizationId
                        "
                        [title]="translate('Private App')">
                        <span class="material-icons">vpn_key</span>
                    </div>
                </div>
                <div class="middleContentContainer">
                    <div class="appImage" [ngSwitch]="asset.serviceType || asset.assetType">
                        <div *ngSwitchCase="'ASSET'">
                            <img mat-card-image src="/assets/images/app-icon.png" alt="app-icon" />
                        </div>
                        <div *ngSwitchCase="'BRIDGE_ASSET'">
                            <img mat-card-image src="/assets/images/bridge-icon.png" alt="bridge-icon" />
                        </div>
                        <div *ngSwitchCase="'WIDGET'">
                            <img mat-card-image src="/assets/images/widget.png" alt="widget" />
                        </div>
                        <div *ngSwitchCase="'RECON'">
                            <img mat-card-image src="/assets/images/recon_large.png" alt="recon_large" />
                        </div>
                        <div *ngSwitchCase="'DASHBOARD'">
                            <img mat-card-image src="/assets/images/dashboard.png" alt="dashboard" />
                        </div>
                        <div *ngSwitchCase="'CONNECTOR'">
                            <span class="material-symbols-outlined text-purple !text-[48px] pb-[20px]">graph_2</span>
                        </div>
                        <div *ngSwitchCase="'PACKAGE'">
                            <img mat-card-image src="/assets/images/package-icon.png" alt="package icon" />
                        </div>
                        <div *ngSwitchDefault>
                            <img
                                mat-card-image
                                *ngIf="fromComponent !== 'bundles' && fromComponent !== 'packages'"
                                src="/assets/images/app-icon.png"
                                alt="app-icon" />
                            <img
                                mat-card-image
                                *ngIf="fromComponent === 'bundles'"
                                src="/assets/images/bundle-icon.png"
                                alt="bundle icon" />
                            <img
                                mat-card-image
                                *ngIf="fromComponent === 'packages'"
                                src="/assets/images/package-icon.png"
                                alt="package icon" />
                        </div>
                    </div>
                    <div
                        *ngIf="fromComponent !== 'assetModelApps__report'"
                        class="appName textEllipsis"
                        [attr.title]="asset.displayName || asset.serviceName || asset.displayName || asset.itemName"
                        [textContent]="asset.displayName || asset.serviceName || asset.name || asset.itemName"></div>
                    <div
                        *ngIf="fromComponent === 'assetModelApps__report'"
                        class="appName taxtEllipsis"
                        [attr.title]="report.name + ' / ' + '(' + (asset.displayName || asset.name) + ')'">
                        <span [textContent]="report.name"></span>
                        <span class="reportUnderApp">
                            (
                            <span [textContent]="asset.name"></span>
                            )
                        </span>
                    </div>
                </div>
                <div class="rightActionsContainer">
                    <div class="appActions" [ngSwitch]="asset.serviceType || asset.assetType">
                        <ng-container *ngIf="fromComponent !== 'bundles'">
                            <ng-container *ngSwitchCase="'ASSET'">
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'approvedApps' ||
                                        (fromComponent === 'assetModelApps_app' && parentAssetType === 'PACKAGE')
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            defaultHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container *ngIf="fromComponent === 'assetModelApps'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            defaultHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'subscriptionManagement' ||
                                        fromComponent === 'appsPendingApproval' ||
                                        fromComponent === 'deactivatedApps'
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                shotCutIcons;
                                                context: { asset: asset, packageApp: packageApp }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'FILE'">
                                <ng-container *ngIf="fromComponent === 'approvedApps'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            defaultHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'subscriptionManagement' ||
                                        fromComponent === 'appsPendingApproval' ||
                                        fromComponent === 'deactivatedApps'
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                shotCutIcons;
                                                context: { asset: asset, packageApp: packageApp }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'BRIDGE_ASSET'">
                                <ng-container *ngIf="fromComponent === 'approvedApps'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            defaultHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'subscriptionManagement' ||
                                        fromComponent === 'appsPendingApproval' ||
                                        fromComponent === 'deactivatedApps'
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="helpIcon; context: { asset: asset, translate: translate }"></ng-container>
                                    <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                shotCutIcons;
                                                context: { asset: asset, packageApp: packageApp }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'RECON'">
                                <ng-container *ngIf="fromComponent === 'approvedApps'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            defaultHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'subscriptionManagement' ||
                                        fromComponent === 'appsPendingApproval' ||
                                        fromComponent === 'deactivatedApps'
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                shotCutIcons;
                                                context: { asset: asset, packageApp: packageApp }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'CONNECTOR'">
                                <ng-container *ngIf="fromComponent === 'approvedApps'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            defaultHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'subscriptionManagement' ||
                                        fromComponent === 'appsPendingApproval' ||
                                        fromComponent === 'deactivatedApps'
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                shotCutIcons;
                                                context: { asset: asset, packageApp: packageApp }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="fromComponent === 'subscriptionManagement'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            viewIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container *ngIf="!isPackagePage">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                cloneIcon;
                                                context: { asset: asset, packageApp: packageApp, translate: translate }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'PACKAGE'">
                                <ng-container *ngIf="fromComponent === 'approvedApps'">
                                    <ng-container *ngTemplateOutlet="defaultHomeIcon; context: { asset: asset }"></ng-container>
                                    <ng-container *ngTemplateOutlet="infoIcon; context: { asset: asset }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container *ngIf="fromComponent === 'assetModelApps'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            defaultHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'subscriptionManagement' ||
                                        fromComponent === 'appsPendingApproval' ||
                                        fromComponent === 'deactivatedApps'
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            helpIcon;
                                            context: { asset: asset, packageApp: packageApp, translate: translate }
                                        "></ng-container>
                                    <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                shotCutIcons;
                                                context: { asset: asset, packageApp: packageApp }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                <!-- Widget Section Starts -->
                                <ng-container *ngIf="fromComponent === 'approvedApps' && asset.assetType === 'WIDGET'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            widgetHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="shotCutIcons; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container *ngIf="fromComponent === 'approvedApps' && asset.assetType !== 'WIDGET'">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            widgetHomeIcon;
                                            context: { asset: asset, packageApp: packageApp }
                                        "></ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        fromComponent === 'subscriptionManagement' ||
                                        fromComponent === 'appsPendingApproval' ||
                                        fromComponent === 'deactivatedApps'
                                    ">
                                    <ng-container
                                        *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                                    <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                shotCutIcons;
                                                context: { asset: asset, packageApp: packageApp }
                                            "></ng-container>
                                    </ng-container>
                                </ng-container>
                                <!-- Widget Section Ends -->
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="fromComponent === 'bundles'">
                            <ng-container
                                *ngTemplateOutlet="
                                    viewIcon;
                                    context: { asset: asset, packageApp: packageApp, translate: translate }
                                "></ng-container>
                            <ng-container
                                *ngTemplateOutlet="
                                    deleteIcon;
                                    context: { asset: asset, packageApp: packageApp, translate: translate }
                                "></ng-container>
                            <ng-container
                                *ngTemplateOutlet="
                                    editIcon;
                                    context: { asset: asset, packageApp: packageApp, translate: translate }
                                "></ng-container>
                            <ng-container *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="fromComponent === 'packages'">
                            <ng-container
                                *ngTemplateOutlet="
                                    deleteIcon;
                                    context: { asset: asset, packageApp: packageApp, translate: translate }
                                "></ng-container>
                            <ng-container
                                *ngTemplateOutlet="
                                    editIcon;
                                    context: { asset: asset, packageApp: packageApp, translate: translate }
                                "></ng-container>
                            <ng-container *ngTemplateOutlet="infoIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                (fromComponent === 'assetModelApps_app' && parentAssetType !== 'PACKAGE') ||
                                fromComponent === 'assetModelApps__report'
                            ">
                            <ng-container
                                *ngTemplateOutlet="defaultHomeIcon; context: { asset: asset, packageApp: packageApp }"></ng-container>
                        </ng-container>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions class="cardActions">
                <ng-container *ngIf="fromComponent === 'approvedApps' || fromComponent === 'assetModelApps_app'">
                    <ng-container [ngSwitch]="asset?.serviceType || asset?.assetType">
                        <ng-container *ngSwitchCase="'ASSET'">
                            <div class="actionsContainer gap-2" *ngIf="!hideLinks && !asset.noPermissions">
                                <ng-container *ngIf="asset.canCreateNewProcess || asset.suspended">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            leftBtnTemplate;
                                            context: { asset: asset, packageApp: packageApp, translate: translate, btnLabel: 'Process Now' }
                                        "></ng-container>
                                </ng-container>
                                <ng-container *ngIf="asset.canViewAllProcesses">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            rightBtnTemplate;
                                            context: {
                                                asset: asset,
                                                packageApp: packageApp,
                                                translate: translate,
                                                btnLabel: 'All Processes'
                                            }
                                        "></ng-container>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'RECON'">
                            <div class="actionsContainer gap-2">
                                <ng-container
                                    *ngTemplateOutlet="
                                        leftBtnTemplate;
                                        context: { asset: asset, packageApp: packageApp, translate: translate, btnLabel: 'Process Now' }
                                    "></ng-container>
                                <ng-container
                                    *ngTemplateOutlet="
                                        rightBtnTemplate;
                                        context: { asset: asset, packageApp: packageApp, translate: translate, btnLabel: 'All Processes' }
                                    "></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'BRIDGE_ASSET'">
                            <div class="actionsContainer">
                                <ng-container
                                    *ngTemplateOutlet="
                                        fullWidthBtnTemplate;
                                        context: {
                                            asset: asset,
                                            packageApp: packageApp,
                                            translate: translate,
                                            btnLabel: 'View Participating Apps'
                                        }
                                    "></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PACKAGE'">
                            <div class="actionsContainer">
                                <ng-container
                                    *ngTemplateOutlet="
                                        fullWidthBtnTemplate;
                                        context: { asset: asset, translate: translate, btnLabel: 'View Participating Apps' }
                                    "></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'CONNECTOR'">
                            <div class="actionsContainer">
                                <ng-container
                                    *ngTemplateOutlet="
                                        fullWidthBtnTemplate;
                                        context: { asset: asset, translate: translate, btnLabel: 'View Participating Apps' }
                                    "></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <div class="actionsContainer gap-2" *ngIf="!hideLinks && !asset.noPermissions">
                                <ng-container *ngIf="asset.canCreateNewProcess || asset.suspended">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            leftBtnTemplate;
                                            context: { asset: asset, packageApp: packageApp, translate: translate, btnLabel: 'Process Now' }
                                        "></ng-container>
                                </ng-container>
                                <ng-container *ngIf="asset.canViewAllProcesses">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            rightBtnTemplate;
                                            context: {
                                                asset: asset,
                                                packageApp: packageApp,
                                                translate: translate,
                                                btnLabel: 'All Processes'
                                            }
                                        "></ng-container>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="fromComponent === 'subscriptionManagement' && !isPackagePage">
                    <ng-container [ngSwitch]="asset.serviceType || asset.assetType">
                        <ng-container *ngSwitchCase="'BRIDGE_ASSET'">
                            <div class="actionsContainer gap-2">
                                <ng-container
                                    *ngTemplateOutlet="
                                        leftBtnTemplate;
                                        context: { asset: asset, translate: translate, btnLabel: 'Subscribe' }
                                    "></ng-container>
                                <ng-container
                                    *ngTemplateOutlet="
                                        rightBtnTemplate;
                                        context: { asset: asset, translate: translate, btnLabel: 'Participating Apps' }
                                    "></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'CONNECTOR'">
                            <div class="actionsContainer">
                                <ng-container
                                    *ngTemplateOutlet="
                                        fullWidthBtnTemplate;
                                        context: { asset: asset, translate: translate, btnLabel: 'Validate & Subscribe' }
                                    "></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <div class="actionsContainer">
                                <ng-container
                                    *ngTemplateOutlet="
                                        fullWidthBtnTemplate;
                                        context: { asset: asset, translate: translate, btnLabel: 'Subscribe' }
                                    "></ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="fromComponent === 'appsPendingApproval' || fromComponent === 'deactivatedApps'">
                    <ng-container *ngIf="(asset.type || asset.assetType) === 'BRIDGE_ASSET'">
                        <div class="actionsContainer">
                            <ng-container
                                *ngTemplateOutlet="
                                    fullWidthBtnTemplate;
                                    context: { asset: asset, translate: translate, btnLabel: 'View Participating Apps' }
                                "></ng-container>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="fromComponent === 'bundles'">
                    <div class="actionsContainer">
                        <ng-container
                            *ngTemplateOutlet="
                                fullWidthBtnTemplate;
                                context: { asset: asset, translate: translate, btnLabel: 'Send Invitation' }
                            "></ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="fromComponent === 'packages'">
                    <div class="actionsContainer">
                        <ng-container
                            *ngTemplateOutlet="
                                fullWidthBtnTemplate;
                                context: { asset: asset, translate: translate, btnLabel: 'View Package' }
                            "></ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="fromComponent === 'assetModelApps__report'">
                    <ng-container *ngIf="asset && (bridge.status === 'APPROVED' || appServiceId) && report.canProcessReports">
                        <div class="actionsContainer" *ngIf="asset.name">
                            <ng-container
                                *ngTemplateOutlet="
                                    fullWidthBtnTemplate;
                                    context: { asset: asset, translate: translate, btnLabel: 'All Reports' }
                                "></ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </mat-card-actions>
        </mat-card>
    </ng-container>
</div>
<div class="cardsContainerLoader w-[100%]" *ngIf="isLoadingCard">
    <mat-card class="loadingAppMatcard appMatcardLoader" *ngFor="let asset of [1, 2, 3, 4, 5]">
        <mat-card-content class="cardContent">
            <div class="leftActionsContainer"></div>
            <div class="middleContentContainer">
                <div class="appImage">
                    <div>
                        <img mat-card-image src="assets/images/app-icon.png" alt="app-icon" />
                    </div>
                </div>
                <div class="appName textEllipsis loaderBlock isLoading">test</div>
            </div>
            <div class="rightActionsContainer"></div>
        </mat-card-content>
        <mat-card-actions class="loadingCardActions">
            <div class="actionsContainer">
                <button class="actionButton loaderBlock isLoading leftBtn">Process Now</button>
                <button class="actionButton loaderBlock isLoading rightBtn">Process Now</button>
            </div>
        </mat-card-actions>
    </mat-card>
</div>

<ng-template #widgetHomeIcon let-asset="asset">
    <ng-container *ngIf="!hideLinks && !asset.noPermissions">
        <div class="assetInformation">
            <div class="material-icons-outlined infoIcon" matTooltip="home" [routerLink]="[widgetsHomePage]">home</div>
        </div>
    </ng-container>
</ng-template>

<ng-template #infoIcon let-asset="asset">
    <div class="assetInformation" *transloco="let translate">
        <div
            class="material-icons-outlined infoIcon"
            (mouseover)="(!asset?.description)"
            (mouseleave)="onInfoOut.emit($event)"
            [matTooltip]="asset.description || translate('Description not found')">
            info
        </div>
    </div>
</ng-template>

<ng-template #defaultHomeIcon let-asset="asset" let-packageApp="packageApp">
    <ng-container *ngIf="!asset.noPermissions || asset.assetType === 'PACKAGE'">
        <div class="assetInformation">
            <div
                class="material-icons-outlined infoIcon"
                [ngClass]="{ invisible: asset.serviceType === 'BRIDGE_ASSET' }"
                (mouseleave)="onInfoOut.emit($event)"
                matTooltip="home"
                AppSelection
                [navigateToAppHomeOnly]="true"
                [app]="asset"
                [bridge]="bridge"
                [package]="packageApp"
                (click)="closeModal.emit(asset)">
                home
            </div>
        </div>
        <div class="assetInformation" [hidden]="parentAssetType !== 'CONNECTOR'">
            <div
                class="material-icons-outlined infoIcon"
                matTooltip="Connector configuration"
                (click)="openInboundIntegrationConfiguration.emit(asset)">
                cloud_download
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #helpIcon let-asset="asset" let-translate="translate">
    <div class="assetHelpDoc assetInformation" *ngIf="asset.assetType !== 'PACKAGE'">
        <div
            class="material-symbols-outlined infoIcon"
            (click)="!asset.helpDocuments && getHelpDocument.emit(asset)"
            [matTooltip]="translate('Help Document')"
            [matMenuTriggerFor]="documentsMenu">
            help
        </div>
        <mat-menu #documentsMenu="matMenu" class="py-1 !bg-white" stop-propagation xPosition="after">
            <app-help-document-view
                [documentList]="asset.helpDocuments"
                (downloadHelpDocument)="downloadHelpDocument.emit($event)"
                (viewHelpDocument)="viewHelpDocument.emit($event)"></app-help-document-view>
        </mat-menu>
    </div>
</ng-template>

<ng-template #shotCutIcons let-asset="asset">
    <div class="assetInformation" [ngClass]="{ 'approved-apps-card': fromComponent === 'approvedApps' }">
        <app-header-shortcuts
            [customIconColor]="'!text-gray-400'"
            [mainApp]="asset"
            [package]="packageApp"
            [fromComponent]="fromComponent"
            [restrictedMenuItems]="['HOME', 'PROCESSES', 'NEW_PROCESS']"
            (onRouteChangeStart)="closeModal.emit()"
            (onUnsubscribe)="unSubscribe($event)"></app-header-shortcuts>
    </div>
</ng-template>

<ng-template #leftBtnTemplate let-asset="asset" let-packageApp="packageApp" let-translate="translate" let-btnLabel="btnLabel">
    <ng-container *ngIf="btnLabel === 'Process Now'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            AppNewProcess
            [disabled]="asset.suspended"
            [loading]="asset.loading?.assetMetaData"
            [app]="asset"
            [appId]="asset.id"
            [hideRipple]="true"
            [bridge]="bridge"
            [package]="packageApp"
            [text]="translate(btnLabel)"
            (buttonClicked)="closeModal.emit()"></material-button>
    </ng-container>
    <ng-container *ngIf="btnLabel === 'Subscribe'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [text]="translate(btnLabel)"
            (buttonClicked)="initiateSubscription.emit({ assets: [asset], individual: true })"></material-button>
    </ng-container>
</ng-template>

<ng-template #rightBtnTemplate let-asset="asset" let-packageApp="packageApp" let-translate="translate" let-btnLabel="btnLabel">
    <ng-container *ngIf="btnLabel === 'All Processes'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [hideRipple]="true"
            AppProcessesSelection
            [loading]="asset.loading?.assetMetaData"
            [app]="asset"
            [appId]="asset.id"
            [bridge]="bridge"
            [package]="packageApp"
            [text]="translate(btnLabel)"
            (buttonClicked)="closeModal.emit()"></material-button>
    </ng-container>
    <ng-container *ngIf="btnLabel === 'Participating Apps'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [labelClassList]="['!max-w-full']"
            [textClassList]="['!block', '!truncate', '!max-w-full']"
            [hideRipple]="true"
            [loading]="asset.loading?.assetMetaData"
            [text]="translate(btnLabel)"
            (buttonClicked)="fetchBridgeAssets.emit(asset)"></material-button>
    </ng-container>
</ng-template>

<ng-template #fullWidthBtnTemplate let-asset="asset" let-translate="translate" let-btnLabel="btnLabel">
    <ng-container *ngIf="btnLabel === 'View Participating Apps'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [hideRipple]="true"
            [text]="translate(btnLabel)"
            (buttonClicked)="fetchBridgeAssets.emit(asset)"></material-button>
    </ng-container>
    <ng-container *ngIf="btnLabel === 'Subscribe'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [text]="translate(btnLabel)"
            (buttonClicked)="initiateSubscription.emit({ assets: [asset], individual: true })"></material-button>
    </ng-container>
    <ng-container *ngIf="btnLabel === 'Validate & Subscribe'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [text]="translate(btnLabel)"
            (buttonClicked)="initiateSubscription.emit({ assets: [asset], individual: true })"></material-button>
    </ng-container>
    <ng-container *ngIf="btnLabel === 'Send Invitation'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [text]="translate(btnLabel)"
            (buttonClicked)="sendBundleInvite.emit(asset)"></material-button>
    </ng-container>
    <ng-container *ngIf="btnLabel === 'View Package'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [text]="translate(btnLabel)"
            (buttonClicked)="viewPackage.emit(asset)"></material-button>
    </ng-container>
    <ng-container *ngIf="btnLabel === 'All Reports'">
        <material-button
            class="w-full truncate"
            [classList]="[
                '!w-full',
                '!h-[30px]',
                '!bg-[#80be8b]',
                '!whitespace-nowrap',
                '!border-none',
                '!rounded-none',
                'hover:!bg-[#00a651]',
                'hover:!text-white'
            ]"
            [hideRipple]="true"
            AppProcessesSelection
            [loading]="asset.loading?.assetMetaData"
            [app]="asset"
            [appId]="asset.id"
            [bridgeId]="bridge?.id"
            [bridge]="bridge"
            [report]="report"
            [getDirectLink]="true"
            [text]="translate(btnLabel)"
            [buttonPurpose]="'ROUTER_LINK'"
            [routerLink]="[report['appProcessesLink']]"
            (buttonClicked)="closeModal.emit()"></material-button>
    </ng-container>
</ng-template>

<ng-template #viewIcon let-asset="asset" let-translate="translate">
    <div class="assetInformation">
        <ng-container *ngIf="fromComponent === 'bundles'">
            <div
                class="material-icons-outlined infoIcon"
                (click)="getInvitations.emit({ bundle: asset, triggerOrigin: 'view' })"
                [matTooltip]="translate('View')">
                remove_red_eye
            </div>
        </ng-container>
        <ng-container [ngSwitch]="asset.serviceType || asset.assetType">
            <ng-container *ngSwitchCase="'CONNECTOR'">
                <div
                    class="material-icons-outlined infoIcon"
                    (click)="viewOrClone.emit({asset, action: 'VIEW', type: 'CONNECTOR'})"
                    [matTooltip]="translate('View')">
                    remove_red_eye
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #deleteIcon let-asset="asset" let-translate="translate">
    <div class="assetInformation">
        <div
            class="material-icons-outlined infoIcon"
            (click)="fromComponent === 'packages' ? deletePackage.emit(asset) : deleteBundle.emit(asset)"
            [matTooltip]="translate('Delete')">
            delete
        </div>
    </div>
</ng-template>

<ng-template #editIcon let-asset="asset" let-translate="translate">
    <div class="assetInformation">
        <div
            class="material-icons-outlined infoIcon"
            (click)="fromComponent === 'packages' ? createPackage.emit(asset) : createBundle.emit(asset)"
            [matTooltip]="translate('Edit')">
            edit
        </div>
    </div>
</ng-template>

<ng-template #cloneIcon let-asset="asset" let-translate="translate">
    <div class="assetInformation">
        <ng-container [ngSwitch]="asset.serviceType || asset.assetType">
            <ng-container *ngSwitchCase="'CONNECTOR'">
                <div
                    class="material-symbols-outlined infoIcon"
                    (click)="viewOrClone.emit({asset, action: 'CLONE', type: 'CONNECTOR'})"
                    [matTooltip]="translate('Clone')">
                    content_copy
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
